/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Foot_BlurbInputs */

const en_mk_foot_blurb = /** @type {(inputs: Mk_Foot_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A workspace for teams whose members are both people and AI agents. Built in Indonesia, in Indonesian first.`)
};

const id_mk_foot_blurb = /** @type {(inputs: Mk_Foot_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruang kerja untuk tim yang anggotanya manusia dan agen AI sekaligus. Dibuat di Indonesia, berbahasa Indonesia.`)
};

/**
* | output |
* | --- |
* | "A workspace for teams whose members are both people and AI agents. Built in Indonesia, in Indonesian first." |
*
* @param {Mk_Foot_BlurbInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_foot_blurb = /** @type {((inputs?: Mk_Foot_BlurbInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Foot_BlurbInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_foot_blurb(inputs)
	return en_mk_foot_blurb(inputs)
});